const AUTH = 'auth';
const AUTH_TOKEN = `${AUTH}/token`;
const AUTH_REFRESH_TOKEN = `${AUTH}/refreshtoken`;
const SOCIAL_LOGIN_URLS = `${AUTH}/oauth`;
const COMPANIES = 'companies';
const AGENCIES = 'agencies';
const ADMIN_REQUESTS = 'admin_access_requests';
const CONVERSATIONS = 'conversations';
const YAP = 'yap';
const CONVERSATION_CREATE_MESSAGE = id => `${CONVERSATIONS}/${id}/messages`;

const COUNTRIES_ENDPOINT = 'countries';
const COUNTRY_CITY_ENDPOINT = countryId => `${COUNTRIES_ENDPOINT}/${countryId}/cities`;
const CITY_ENDPOINT = `${COUNTRIES_ENDPOINT}/cities`;
const CURRENCIES = 'currencies';
const FILTER_AGGREGATION_SEARCH = endpoint => `${endpoint}/aggregations`;
const FORGOT_PASSWORD = `${AUTH}/forgotPassword`;
const LANGUAGES_LIST = 'languages';
const PERFORMANCES = 'performances';
const USER_PERFORMANCES = 'users/performances';
const PRODUCTIONS = 'productions';
const CHANGE_REQUEST = 'change_requests';
const PRODUCTIONS_REVIVALS = 'productions/revivals';
const CASTS_ENDPOINT = `${PRODUCTIONS}/castings`;
const PRODUCTIONS_AGGREGATIONS = 'productions/aggregations';
const WORKS_AGGREGATIONS = 'works/aggregations';
const PRODUCTIONS_NEWANDRARE = 'productions/newandrare';
const NEWANDRARE_AGGREGATIONS = 'productions/newandrare/aggregations';
const COMPETITIONS = 'competitions';
const COMPETITIONS_AGGREGATIONS = 'competitions/aggregations';
const REPERTOIRE = 'repertoire';
const PROFILES_ENDPOINT = 'profiles';
const PAGERULES_ENDPOINT = 'pagerules';
const PROFILES_BIO_ENDPOINT = profileId => `${PROFILES_ENDPOINT}/${profileId}/descriptions`;
const PROFILE_CONTACTS_ENDPOINT = profileId => `${PROFILES_ENDPOINT}/${profileId}/contacts`;
const ARTIST_RECOMMENDATIONS = profileId => `${PROFILES_ENDPOINT}/${profileId}/recommendations`;
const ARTIST_TRANSLATIONS = profileId => `${PROFILES_ENDPOINT}/${profileId}/${TRANSLATIONS}`;
const SEARCH_ENDPOINT = 'search';
const JOBS_ENDPOINT = 'jobs';
const MUSICAL_WORK_ENDPOINT = 'works';
const MUSICAL_WORK_TYPES_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/types`;
const WORK_STAGING_TYPES_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/stagingTypes`;
const MUSICAL_WORK_STYLES_ENDPOINT = `${MUSICAL_WORK_ENDPOINT}/styles`;
const VENUES = 'venues';
const VENUES_STAGES_ENDPOINT = venueId => `${VENUES}/${venueId}/stages`;
const VENUES_CONTACTS = id => `${VENUES}/${id}/${CONTACTS}`;
const CONTACTS = 'contacts';
const VENUES_AGGREGATIONS = 'venues/aggregations';
const NETWORK_INVITATIONS = 'network/invitations';
const PROJECT_CANDIDATES = id => `${PROJECTS}/${id}/candidates`;
const PROJECTS = 'projects';
const FESTIVALS = 'festivals';
const FESTIVAL_CONTACTS = id => `${FESTIVALS}/${id}/${CONTACTS}`;
const FESTIVAL_EMPLOYEES = festivalId => `${FESTIVALS}/${festivalId}/${EMPLOYEES}`;
const FESTIVAL_CERTAIN_EMPLOYEE = (festivalId, employeeId) =>
  employeeId ? `${FESTIVALS}/${festivalId}/${EMPLOYEES}/${employeeId}` : `${FESTIVALS}/${festivalId}/${EMPLOYEES}`;
const FESTIVAL_DESCRIPTIONS = id => `${FESTIVALS}/${id}/descriptions`;
const FESTIVAL_TRANSLATIONS = festivalId => `${FESTIVALS}/${festivalId}/${TRANSLATIONS}`;
const FESTIVAL_YOUNG_ARTIST_PROGRAM = festivalId => `${FESTIVALS}/${festivalId}/yap`;

const ARTISTS = 'artists';
const VIDEOS = 'proxy/videos';
const ARTICLES = 'articles';
const COMPOSER = 'works/composers';
const COMPOSER_REVIEWS = id => `${COMPOSER}/${id}/reviews`;
const REVIEWS_ENDPOINT = 'reviews';
const WORK_ROLES = 'works/roles';
const AGENTS = 'agents';
const RENTALS = 'rentals';
const OFFICES = 'offices';
const NETWORK = 'network';
const CONNECTIONS = 'connections';
const INVITATIONS = 'invitations';
const ONTHISDAY = date => `stats/onthisday${date ? `/${date}` : ''}`;
const ACCOUNT_CREATE = 'users';
const ACCOUNT_SETTINGS = userId => `users/${userId}/settings`;
const USER_PAYMENTS = userId => `users/${userId}/payments`;
const SUBSCRIPTIONS = 'subscriptions';
const PRODUCTS = 'products';
const CHECKOUTS = 'checkouts';
const REGISTRATIONS = 'users/registrations';
const ADVANCED_STATS = 'stats/advanced';
const ADVANCED_STATS_AGGREGATIONS = 'stats/advanced/aggregations';
const USER_SUBSCRIPTIONS = userId => `users/${userId}/subscriptions`;
const PRODUCTION_CASTS = productionId => `productions/${productionId}/casts`;
const AGENT_PROFILE_AGENCIES = `${AGENCIES}/${AGENTS}`;
const ARTIST_PROFILE_AGENCIES = `${AGENCIES}/${ARTISTS}`;

const AGENCY = id => `${AGENCIES}/${id}`;
const AGENCY_ARTISTS = id => `${AGENCIES}/${id}/${ARTISTS}`;
const AGENCY_AGENTS = id => `${AGENCIES}/${id}/${AGENTS}`;
const AGENCY_CONTACTS = id => `${AGENCIES}/${id}/${CONTACTS}`;
const AGENCY_REQUESTS = id => `${AGENCIES}/${id}/access_requests`;
const AGENCY_ACTIONS = id => `${AGENCIES}/${id}/actions`;

const AGENCY_CERTAIN_AGENT = (agencyId, agentId) => `${AGENCIES}/${agencyId}/${AGENTS}/${agentId}`;

const OFFICE = (agencyId, officeId) => `${AGENCIES}/${agencyId}/${OFFICES}${officeId ? `/${officeId}` : ''}`;

const COMPANY_VENUES = companyId => `${COMPANIES}/${companyId}/venues`;
const FESTIVAL_VENUES = festivalId => `${FESTIVALS}/${festivalId}/venues`;
const EMPLOYEES = 'employees';
const TRANSLATIONS = 'translations';
const COMPANY_DESCRIPTIONS = companyId => `${COMPANIES}/${companyId}/descriptions`;
const COMPANY_EMPLOYEES = companyId => `${COMPANIES}/${companyId}/${EMPLOYEES}`;
const COMPANY_ACTIONS = id => `${COMPANIES}/${id}/actions`;
const FESTIVAL_ACTIONS = id => `${FESTIVALS}/${id}/actions`;
const COMPANY_CONTACTS = companyId => `${COMPANIES}/${companyId}/${CONTACTS}`;
const COMPANY_CERTAIN_EMPLOYEE = (companyId, empId) =>
  empId ? `${COMPANIES}/${companyId}/${EMPLOYEES}/${empId}` : `${COMPANIES}/${companyId}/${EMPLOYEES}`;
const COMPANY_TRANSLATIONS = companyId => `${COMPANIES}/${companyId}/${TRANSLATIONS}`;
const COMPANY_YOUNG_ARTIST_PROGRAM = companyId => `${COMPANIES}/${companyId}/yap`;
const COMPANY_FESTIVALS = companyId => `${COMPANIES}/${companyId}/${FESTIVALS}`;
const COMPANY_FESTIVALS_ASSOCIATED = `${COMPANIES}/${FESTIVALS}`;
const RENTAL_ACTION = prodId => `${PRODUCTIONS}/${prodId}/${RENTALS}`;
const RENTAL_INCLUDES = (prodId, rentalId) => `${PRODUCTIONS}/${prodId}/${RENTALS}/${rentalId}`;

const MW_WORK_TYPES = workId => `${PRODUCTIONS}/${MUSICAL_WORK_TYPES_ENDPOINT}/${workId}`;

const PROFILE_CONNECTIONS = profileId => `${NETWORK}/connections?participant_id=${profileId}`;
const PROFILE_ACCESSES = `${PROFILES_ENDPOINT}/profileaccesses`;
const PROFILE_ACCESS_REQUESTS = `${PROFILES_ENDPOINT}/profileaccessrequests`;
const SET_PROFILE_ACCESS_REQUESTS = profileId => `${PROFILES_ENDPOINT}/${profileId}/profileaccessrequests`;

const ARTIST_AGREEMENTS = `${AGENCIES}/agreements`;

const AGENCY_AGENTS_INVITATIONS = agencyId => `${AGENCIES}/${agencyId}/${INVITATIONS}`;
const AGENCY_OFFICES = agencyId => `${AGENCIES}/${agencyId}/${OFFICES}`;

const PROFILE_ACTIONS = profileId => `${PROFILES_ENDPOINT}/${profileId}/actions`;

const PROFILE_REPERTOIRE = profileId => `${PROFILES_ENDPOINT}/${profileId}/${REPERTOIRE}`;
const MEDIA = 'media';
const MEDIA_SHOWREELS = 'media/showreelsmedia';
const MEDIA_SHOWREELS_ORDER = 'media/showreelsmedia/order';
const PRODUCTION_MEDIA = id => `productions/${id}/media`;
const PRODUCTION_REVIEWS_V1 = id => `api/productions/${id}/reviews`;
const MEDIA_ATTRIBUTES = 'media/attributes';
const MEDIA_TAGS = 'media/tags';
const MEDIA_ACTIONS = mediaId => `media/${mediaId}/actions`;
const MEDIA_ORDER = `${MEDIA}/order`;
const REVIEWS = profileId => `${PROFILES_ENDPOINT}/${profileId}/reviews`;
const PRODUCTION_REVIEWS = reviewId => `reviews/${reviewId}`;
const NEW_REVIEWS = 'reviews';
const REVIEW_ACTIONS = reviewId => `${NEW_REVIEWS}/${reviewId}/actions`;
const REVIEW_ORDER = `${NEW_REVIEWS}/order`;

const STATS_NUMBERS = `stats/numbers`;
const STATS_NUMBERS_BY_ID = id => `stats/numbers/${id}`;
const SEASONS = 'seasons';
const SEASONS_COMPANIES = 'seasons/companies';
const PROFESSIONS = 'professions';
const PROFESSION_QUALIFICATIONS_ENDPOINT = `${PROFESSIONS}/qualifications`;
const AOS_PROFESSIONS = `${COMPANIES}/employees/professions`;
const FESTIVAL_PROFESSIONS = `${FESTIVALS}/employees/professions`;
const PROFILE_PROFESSION = profileId => `${PROFILES_ENDPOINT}/${profileId}/${PROFESSIONS}`;
const REGIONS = 'regions';
const PING_URL = 'users/ping/status';
const BANK_CARDS = 'users/cards';
const REQUESTACCESS = `${PROFILES_ENDPOINT}/accessrequests`;
const PRIVACY_OPTIONS = 'privacy_attributes';
const PRODUCTION_DOCUMENTS = `${PRODUCTIONS}/documents`;
const PRODUCTION_DOCUMENTS_V1 = id => `api/productions/${id}/documents`;
const PRODUCTION_PRIVACY = productionId => `${PRODUCTIONS}/${productionId}/privacy`;

const PRODUCTION_DATES = productionId => `${PRODUCTIONS}/${productionId}/dates`;
const PRODUCTION_DATE_ACTIONS = productionId => `${PRODUCTIONS}/${productionId}/actions`;
const PRODUCTION_CHNAGE_REQUEST_ACTIONS = productionId => `${CHANGE_REQUEST}/${productionId}/actions`;
const PRODUCTION_DOCUMENTS_BY_ID = productionId => `${PRODUCTIONS}/${productionId}/documents`;
const NEW_PRODUCTION_DOCUMENT_BY_ID = (productionId, documentId) =>
  `${PRODUCTIONS}/${productionId}/documents/${documentId}`;
const PRODUCTION_ACTIONS = productionId => `${PRODUCTIONS}/${productionId}/actions`;
const PRODUCTION_SYNOPSIS = productionId => `${PRODUCTIONS}/${productionId}/synopsis`;
const PRODUCTION_SYNOPSIS_BY_ID = (productionId, synopsisId) => `${PRODUCTIONS}/${productionId}/synopsis/${synopsisId}`;
const PRODUCTION_ENSEMBLES = productionId => `${PRODUCTIONS}/${productionId}/ensembles`;
const PRODUCTION_TICKETS = productionId => `${PRODUCTIONS}/${productionId}/tickets`;
const ENSEMBLES = 'ensembles';
const PRODUCTION_WORKS = productionId => `${PRODUCTIONS}/${productionId}/works`;

const SUPPORT_REQUESTS = 'users/supportRequests';
const MEDIA_SUGGESTIONS = 'media/suggestions';

const NOTIFICATIONS = 'notifications';
const USER_NOTIFICATIONS = 'notifications';
const PROFILE_NOTIFICATIONS = 'profiles/notifications';

const ARTISTS_WORKED_WITH = userId => `users/${userId}/referrals`;
const GIFT_SUBSCRIPTIONS = userId => `users/${userId}/referralStatus`;
const USER_REWARD_BALANCE = 'users/rewardBalance';
const USER_REFERRALS = `users/giftTokens`;
const AGENCY_ARTIST_ROSTER = `agencyArtists`;
const USER_NEW_PERFORMANCES = 'users/performances';

module.exports = {
  ACCOUNT_CREATE,
  ACCOUNT_SETTINGS,
  ADMIN_REQUESTS,
  ADVANCED_STATS,
  ADVANCED_STATS_AGGREGATIONS,
  AGENCIES,
  YAP,
  AGENCY,
  AGENCY_AGENTS,
  AGENCY_AGENTS_INVITATIONS,
  AGENCY_ARTISTS,
  AGENCY_CERTAIN_AGENT,
  AGENCY_CONTACTS,
  AGENCY_OFFICES,
  AGENCY_REQUESTS,
  AGENT_PROFILE_AGENCIES,
  AGENTS,
  AOS_PROFESSIONS,
  ARTICLES,
  ARTIST_AGREEMENTS,
  ARTIST_PROFILE_AGENCIES,
  ARTIST_RECOMMENDATIONS,
  ARTIST_TRANSLATIONS,
  ARTISTS,
  AUTH,
  AUTH_REFRESH_TOKEN,
  AUTH_TOKEN,
  SOCIAL_LOGIN_URLS,
  BANK_CARDS,
  CASTS_ENDPOINT,
  CHECKOUTS,
  CITY_ENDPOINT,
  COMPANIES,
  COMPANY_CERTAIN_EMPLOYEE,
  COMPANY_CONTACTS,
  COMPANY_DESCRIPTIONS,
  COMPANY_EMPLOYEES,
  COMPANY_ACTIONS,
  FESTIVAL_ACTIONS,
  COMPANY_TRANSLATIONS,
  COMPANY_YOUNG_ARTIST_PROGRAM,
  COMPANY_FESTIVALS_ASSOCIATED,
  COMPANY_FESTIVALS,
  COMPETITIONS,
  COMPETITIONS_AGGREGATIONS,
  COMPOSER,
  COMPOSER_REVIEWS,
  CONNECTIONS,
  CONVERSATION_CREATE_MESSAGE,
  CONVERSATIONS,
  COUNTRIES_ENDPOINT,
  COUNTRY_CITY_ENDPOINT,
  CURRENCIES,
  EMPLOYEES,
  FESTIVAL_CERTAIN_EMPLOYEE,
  FESTIVAL_CONTACTS,
  FESTIVAL_DESCRIPTIONS,
  FESTIVAL_EMPLOYEES,
  FESTIVAL_PROFESSIONS,
  FESTIVALS,
  FESTIVAL_TRANSLATIONS,
  FESTIVAL_YOUNG_ARTIST_PROGRAM,
  FILTER_AGGREGATION_SEARCH,
  FORGOT_PASSWORD,
  LANGUAGES_LIST,
  PERFORMANCES,
  USER_PERFORMANCES,
  PRODUCTIONS,
  CHANGE_REQUEST,
  PRODUCTIONS_REVIVALS,
  PRODUCTIONS_NEWANDRARE,
  NEWANDRARE_AGGREGATIONS,
  REPERTOIRE,
  PROFILES_ENDPOINT,
  PROFILE_ACCESSES,
  PROFILE_ACCESS_REQUESTS,
  SEARCH_ENDPOINT,
  INVITATIONS,
  JOBS_ENDPOINT,
  MEDIA,
  MEDIA_ATTRIBUTES,
  MEDIA_TAGS,
  MUSICAL_WORK_ENDPOINT,
  MUSICAL_WORK_STYLES_ENDPOINT,
  MUSICAL_WORK_TYPES_ENDPOINT,
  NETWORK,
  NETWORK_INVITATIONS,
  OFFICE,
  OFFICES,
  ONTHISDAY,
  SUBSCRIPTIONS,
  PRODUCTS,
  USER_SUBSCRIPTIONS,
  PROFILE_CONNECTIONS,
  PROFILE_REPERTOIRE,
  REVIEWS,
  PRODUCTION_REVIEWS,
  PRODUCTION_REVIEWS_V1,
  NEW_REVIEWS,
  REVIEW_ACTIONS,
  STATS_NUMBERS,
  STATS_NUMBERS_BY_ID,
  SEASONS,
  SEASONS_COMPANIES,
  PROFESSIONS,
  PROFESSION_QUALIFICATIONS_ENDPOINT,
  REGIONS,
  REQUESTACCESS,
  PAGERULES_ENDPOINT,
  PING_URL,
  PRIVACY_OPTIONS,
  PRODUCTION_ACTIONS,
  PRODUCTION_CASTS,
  PRODUCTION_DATES,
  PRODUCTION_DATE_ACTIONS,
  PRODUCTION_DOCUMENTS,
  PRODUCTION_DOCUMENTS_BY_ID,
  PRODUCTION_DOCUMENTS_V1,
  MEDIA_ACTIONS,
  PRODUCTION_PRIVACY,
  PRODUCTIONS_AGGREGATIONS,
  SET_PROFILE_ACCESS_REQUESTS,
  PROFILE_CONTACTS_ENDPOINT,
  PROFILE_PROFESSION,
  PROFILES_BIO_ENDPOINT,
  PROJECT_CANDIDATES,
  PROJECTS,
  REGISTRATIONS,
  RENTALS,
  REVIEWS_ENDPOINT,
  SUPPORT_REQUESTS,
  MEDIA_SUGGESTIONS,
  PRODUCTION_SYNOPSIS,
  PRODUCTION_ENSEMBLES,
  NEW_PRODUCTION_DOCUMENT_BY_ID,
  PRODUCTION_SYNOPSIS_BY_ID,
  PRODUCTION_TICKETS,
  PRODUCTION_WORKS,
  USER_PAYMENTS,
  VENUES,
  VENUES_AGGREGATIONS,
  VENUES_CONTACTS,
  VENUES_STAGES_ENDPOINT,
  WORK_ROLES,
  VIDEOS,
  ENSEMBLES,
  NOTIFICATIONS,
  PRODUCTION_MEDIA,
  PRODUCTION_CHNAGE_REQUEST_ACTIONS,
  USER_NOTIFICATIONS,
  PROFILE_NOTIFICATIONS,
  PROFILE_ACTIONS,
  AGENCY_ACTIONS,
  MEDIA_SHOWREELS,
  MEDIA_SHOWREELS_ORDER,
  REVIEW_ORDER,
  MEDIA_ORDER,
  RENTAL_ACTION,
  RENTAL_INCLUDES,
  COMPANY_VENUES,
  FESTIVAL_VENUES,
  WORKS_AGGREGATIONS,
  ARTISTS_WORKED_WITH,
  GIFT_SUBSCRIPTIONS,
  USER_REFERRALS,
  USER_REWARD_BALANCE,
  AGENCY_ARTIST_ROSTER,
  USER_NEW_PERFORMANCES,
  MW_WORK_TYPES,
  WORK_STAGING_TYPES_ENDPOINT,
};
